export const sv = {
    LEFT: 'Till vänster: Flytta till föregående dag.',
    RIGHT: 'Höger: Flytta till nästa dag.',
    DOWN: 'Ned: Flytta till nästa rad.',
    UP: 'Upp: Flytta till föregående rad.',
    PGUP: 'PgUp: Flytta till föregående månad.',
    PGDOWN: 'Page down: Flyttar till nästa månad.',
    HOME: 'Home: Gå till föregående år.',
    END: 'Slut: Flytta till nästa år.',
    ESC: 'Esc/i Dag/stäng: Stäng kalender.',
    TITLE: 'Tangentbord Instruktioner'
};
